module.exports = __webpack_public_path__ + "img/p-31.fcc6bbe5.png";